// import Vue from 'vue';
// import VueSocketIO from 'vue-socket.io';

// Vue.use(
//   new VueSocketIO({
//     debug: true,
//     connection: process.env.VUE_APP_SOCKET_URL,
//     options: { path: '/socket/socket.io' }
//   })
// );

import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import { io } from 'socket.io-client';

// const options = { path: '/socket/socket.io/' }; //Options object to pass into SocketIO

Vue.use(
  new VueSocketIO({
    debug: true,
    transports: ['websocket'],
    connection: io(process.env.VUE_APP_SOCKET_URL, { path: '/socket/socket' }) //options object is Optional
  })
);
